var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M18 7.5h-7.5V0h-3v7.5H0v3h7.5V18h3v-7.5H18v-3z","fill":"#974900"}})])}
var staticRenderFns = []

export { render, staticRenderFns }